// assets/slideshow-autoplay.js
document.addEventListener('DOMContentLoaded', () => {
  const INTERVAL = 3000; // ミリ秒：切り替え間隔
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // 画面上に見えているか判定（非表示ボタンは除外）
  const isVisible = (el) => !!(el && el.offsetParent !== null && el.getClientRects().length);

  // 「Next slide」と表示されている操作要素を横断的に取得（button/a/[role=button]）
  function findNextButtons(root = document) {
    const candidates = root.querySelectorAll('button, a, [role="button"]');
    const result = [];
    candidates.forEach((el) => {
      const text = (el.innerText || el.textContent || '').trim().toLowerCase();
      const aria = (el.getAttribute('aria-label') || '').trim().toLowerCase();
      // “next slide” の表示 or aria-label を優先して拾う
      if ((/next slide/.test(text) || /next/.test(aria)) && isVisible(el)) {
        result.push(el);
      }
    });
    return result;
  }

  function attachAutoplay(root = document) {
    const nextButtons = findNextButtons(root);
    if (!nextButtons.length) return;

    nextButtons.forEach((btn) => {
      if (btn.dataset.autoplayAttached) return; // 二重付与防止
      btn.dataset.autoplayAttached = '1';

      // 近いコンテナ（セクション等）を推定し、ホバー/フォーカス中は一時停止
      const container = btn.closest('section, .slideshow, .slider, .carousel') || document;
      let paused = false;
      container.addEventListener('mouseenter', () => (paused = true));
      container.addEventListener('mouseleave', () => (paused = false));
      container.addEventListener('focusin', () => (paused = true));
      container.addEventListener('focusout', () => (paused = false));

      // 定期的に「次へ」をクリック（タブ非表示・ボタン非表示時は停止）
      setInterval(() => {
        if (paused || document.hidden) return;
        if (!isVisible(btn)) return;
        btn.click();
      }, INTERVAL);
    });
  }

  // 初回アタッチ
  attachAutoplay();

  // Shopifyのセクションが再描画された場合にも再アタッチ
  document.addEventListener('shopify:section:load', (e) => attachAutoplay(e.target));
});
